import { BackButton } from "@/components/custom/BackButton"
import { PageTitle } from "@/components/custom/PageTitle"
import { useForm } from "react-hook-form"
import { z } from "zod"
import { zodResolver } from "@hookform/resolvers/zod"
import { Form } from "@/components/ui/form"
import { Button } from "@/components/ui/button"
import { useSelector, useDispatch } from "react-redux"
import { AppDispatch, RootState } from "@/redux"
import { useNavigate } from "react-router-dom"
import { createOrganization } from "@/services/organizationService"
import { TextInputField } from "@/components/custom/InputField/TextInputField"

const formSchema = z.object({
  name: z.string().min(3, {
    message: 'Organization name must be at least 3 characters.'
  })
})

export const CreateOrganization = () => {
  const navigate = useNavigate()
  const dispatch: AppDispatch = useDispatch()
  const { token } = useSelector((state: RootState) => state.user)
  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      name: "",
    },
  })

  const onFormSubmit = async (
    values: z.infer<typeof formSchema>
  ) => {
    if (!token) {
      return
    }
    const response = await dispatch(createOrganization(token, values))
    if (response.data) {
      form.reset({ name: "" })
      navigate('/organizations')
    }
  }

  return (
    <div className="protectedPageLayout">
      <BackButton buttonLink="/organizations" buttonText="Back to Organizations" />
      <PageTitle title="Add New Organization" />
      <Form {...form}>
        <form
          onSubmit={form.handleSubmit(onFormSubmit)}
          className="space-y-8 flex flex-col items-start"
        >
          <TextInputField
            form={form}
            schema={formSchema}
            name="name"
            label="Organization Name"
            error={!!form.formState.errors.name}
            placeholder="XYZ"
            required={true}
          />
          <Button type="submit" className="mb-2 font-semibold">
            Add New Organization
          </Button>
        </form>
      </Form>
    </div>
  )
}
